<template>
  <section class="validation-messages board-component bg-white">
    <div class="validation-messages__header">
      <h2 class="validation-messages__title f-16 p-600 no-select text-primary">
        <IconDashboard class="text-primary" />
        Itens pendentes
      </h2>
      <button
        type="button"
        class="close"
        @click="closeEditPanel"
      >
        <IconClose size="xs" />
      </button>
    </div>
    <div class="custom-scrollbar">
      <div class="validation-messages__list">
        <template v-for="(instanceMessages, instanceId) in validationMessages">
          <template v-for="(fieldMessages, groupModelPath) in instanceMessages">
            <div
              v-for="(message, index) in fieldMessages"
              :key="`${instanceId}-${groupModelPath}-${index}`"
              class="validation-messages__list__item"
            >
              <div class="validation-messages__list__item__text">
                <IconWarning
                  size="xs"
                  class="text-danger"
                />
                <p>
                  <strong>
                    <span v-if="instance(instanceId).name">
                      {{ instance(instanceId).name }}:</span
                    >
                  </strong>
                  {{ message }}
                </p>
              </div>

              <div class="validation-messages__list__item__buttons">
                <button
                  class="link"
                  @click="goToField(instanceId, groupModelPath)"
                >
                  Corrigir
                </button>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import IconDashboard from '@/components/icons/IconDashboard.vue';
import IconWarning from '@/components/icons/IconWarning.vue';
import IconClose from '@/components/icons/IconClose.vue';

export default {
  name: 'ValidationPanel',
  components: {
    IconClose,
    IconDashboard,
    IconWarning,
  },
  computed: {
    ...mapState(['validationMessages']),
    ...mapGetters(['instance']),
  },
  methods: {
    goToField(instanceId, groupModelPath) {
      this.$emit('closeSeoViewer');

      const [activeInstanceExpandedGroup] = groupModelPath.split('/');

      this.setActiveInstanceExpandedGroup(activeInstanceExpandedGroup);
      this.toggleActiveInstance(instanceId);
    },
    closeEditPanel() {
      this.toggleValidationPanelDisplay(null);
    },
    ...mapActions([
      'setActiveInstanceExpandedGroup',
      'toggleActiveInstance',
      'toggleValidationPanelDisplay',
    ]),
  },
};
</script>

<style scoped lang="scss">
.validation-messages {
  box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.15);
  right: 8px;
  top: 0;
  width: 450px;
  padding: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;

  .custom-scrollbar {
    flex-grow: 1;
    margin: 0;
  }

  &__header {
    padding: 20px 30px;
    display: flex;
    justify-content: space-between;

    .close {
      width: 32px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid $lb-gray;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__title {
    background-color: $lb-white;
    flex: 0 auto;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: $lb-medium;

    .icon {
      margin-right: 5px;
    }
  }

  &__list {
    padding: 15px 20px;
    &__item {
      padding-bottom: 10px;
      border-bottom: 1px solid #e8e8e8;

      &:not(:first-child) {
        padding-top: 10px;
      }

      &__text {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .icon {
          flex: 0 0 auto;
        }

        p {
          font-size: $size-smaller;
          line-height: 18px;
          margin-left: 10px;
        }
      }

      &__buttons {
        padding: 0 24px;

        .link {
          font-size: $size-smaller;
          font-weight: $lb-medium;
          color: $crm-blue-primary;
          border: none;
          background: none;
          padding: 0;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
            color: $crm-blue-primary;
          }
        }
      }
    }
  }
}
</style>
